import { Col, Drawer, Row } from "antd";
import classnames from 'classnames';
import React, {PropsWithChildren, ReactNode, useState} from "react";
import LeftMenu from "../LeftMenu";
import { AppSupportBar } from "./AppSupportBar";
import DemoMessage from "./DemoMessage";
import styles from './Main.module.scss';
import {CopyrightNotice} from "../common/CopyrightNotice";

type MainProps = PropsWithChildren<{
    title?: ReactNode
    pageClassName?: string
    containerClassName?: string
    showSidebarMenu?: boolean
    secondaryNavigation?: React.ReactNode
}>

const Main = ({
  title, pageClassName, containerClassName, children, showSidebarMenu = true, secondaryNavigation
}: MainProps) => {

    const [sideBarVisible, setSideBarVisible] = useState(false)


    return <>
        <AppSupportBar onClickMenu={showSidebarMenu ? () => setSideBarVisible(!sideBarVisible) : undefined} />
        { secondaryNavigation }
        { showSidebarMenu ?
            <Drawer
                className={styles['menu-drawer']}
                open={sideBarVisible}
                closable={false}
                placement="left"
                onClose={() => setSideBarVisible(false)}
                width={80}
            >
                <LeftMenu/>
            </Drawer> : null
        }
        <Row>
            <Col span={24} className={classnames("main-container", pageClassName)}>
                <Row>
                    <DemoMessage />
                    <Col span={24} className={classnames(
                        "contents", containerClassName, showSidebarMenu ? styles.defaultContainer : styles.fullWidthContainer
                    )}>
                        <Row>
                            <Col span={24}>
                                {children}
                            </Col>
                        </Row>
                        <CopyrightNotice/>
                    </Col>
                </Row>
            </Col>
        </Row>
    </>
}


export default Main